export default "__VITE_ASSET__DLyzxISI__$_?url__"